import { ListItemIcon, MenuItem } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import StoreIcon from "@mui/icons-material/Store";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import { ROW_ACTIONS } from "../config/ROW_ACTIONS";

export const buildRowActions = ({ row, closeMenu, onAction }) => {
  const activo = Number(row.activo) === 1;

  return [
    <MenuItem
      key="editar"
      onClick={() => {
        closeMenu();
        onAction({ type: ROW_ACTIONS.EDITAR, row });
      }}
    >
      <ListItemIcon>
        <EditIcon color="primary" fontSize="small" />
      </ListItemIcon>
      Editar
    </MenuItem>,
    <MenuItem
      key="sucursales"
      onClick={() => {
        closeMenu();
        onAction({ type: ROW_ACTIONS.SUCURSALES, row });
      }}
    >
      <ListItemIcon>
        <StoreIcon color="secondary" fontSize="small" />
      </ListItemIcon>
      Gestionar sucursales
    </MenuItem>,
    <MenuItem
      key="toggle-estado"
      onClick={() => {
        closeMenu();
        onAction({ type: ROW_ACTIONS.TOGGLE_ESTADO, row });
      }}
    >
      <ListItemIcon>
        {activo ? (
          <ToggleOffIcon color="error" fontSize="small" />
        ) : (
          <ToggleOnIcon color="success" fontSize="small" />
        )}
      </ListItemIcon>
      {activo ? "Desactivar" : "Activar"}
    </MenuItem>,
  ];
};
